const getChartData = variables => [
  {
    name: "Predict",
    variables: variables.filter(
      v => v.in_predict_set && v["@type"] === "column"
    )?.length,
    fill: "#A5B3FC",
  },
  {
    name: "Relevant",
    variables: variables.filter(v => v.in_relevant_set)?.length ?? 0,
    fill: "#818DF8",
  },
  {
    name: "Analyzed",
    variables: variables.filter(v => v["@type"] === "column")?.length ?? 0,
    fill: "#6365F1",
  },
  {
    name: "Total",
    variables: variables.length,
    fill: "#4E46E5",
  },
];

export { getChartData };
